import { SimpleContainerFTNodeOptions } from "./typings";

const buildClassNameToParameterConditionMap = (options: SimpleContainerFTNodeOptions) => ({
  fullScreenWidth: options.fullWidth,
  whiteBackground: options.backgroundColor === "white",
  "region-bottom-border": options.border === "bottom",
  "l-x-padding-three xl-x-padding-three all-y-padding-six": options.containerName === "dx-main-content",
  "all-b-padding-six": options.containerName === "dx-sidebar-content",
  dxPageContent: options.containerName === "dx-page-content",
  "region-without-border": options.border && options.border.includes("none"),
  "bex-homepage-module": options.brandModulePadding === "bex_padding",
  "comet-homepage-module": options.brandModulePadding === "comet_padding",
});

export const getExtraClassNameBasedOnParameters = (options: SimpleContainerFTNodeOptions) => {
  const classMap = buildClassNameToParameterConditionMap(options);

  return Object.keys(classMap)
    .filter((x) => classMap[x])
    .join(" ");
};
